import gql from "graphql-tag";

export const GET_CUSTOMERS = gql`
query ($orgId:uuid!){
  customerArr: Customer(where: {orgId: {_eq: $orgId}}) {
    id
    name
    mobile
    email
    phone
    city
    state
    companyName
  }
}`

/* ---------------- Missing Retail Sales Entry ----------------- */
export const GET_CUSTOMER_BY_SUB_BATCH = gql`
query getCustomerBySubBatch($subBatch: String!){
  inv: ProductInventorySales(where: { subBatch: {_eq: $subBatch}}){
    id
    name: customerName   
    email: customerEmail        
    companyName: customerCompany
    activationDate
    expirationDate
    batchId
    subBatchId
    productId
    licenseKey
  }
}`

export const CHECK_CUSTOMER_BY_EMAIL = gql`
query checkCustomerByEmail($email: String!){
  Customer(where: { email: {_eq: $email}}){
    id    
  }
}`
/* ------------------------------------------------------------- */
